import { Injectable } from '@angular/core';
import { ApiResponse } from 'src/AngularJS/Models/api-response.model';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ModuleManagerExportFormat } from 'src/shared/models/module-manager/module-manager-options.model';
import { GaugeData } from './gauge.models';

@Injectable({
    providedIn: 'root'
})
export class GaugeService {

    constructor(
        private cvApi: CVApiService,
    ) {
    }

    public async loadData(moduleKey: string, isAutoRefresh?: boolean, isFirstLoad?: boolean, abort?: Promise<void>): Promise<ApiResponse<GaugeData>> {
        const moduleRenderUrl = await this.cvApi.getModuleRenderEndPoint(moduleKey);
        return await this.cvApi.get<GaugeData>(`/api/v2/dashboards/modules/kpiData/${moduleKey}?isAutoRefresh=${!!isAutoRefresh}&isFirstLoad=${!!isFirstLoad}&forGauge=true`, moduleRenderUrl, abort);
    }

    public async loadDataForExport(moduleKey: string, format: ModuleManagerExportFormat = ModuleManagerExportFormat.Excel): Promise<ApiResponse<string>> {
        const moduleRenderUrl = await this.cvApi.getModuleRenderEndPoint(moduleKey);
        return await this.cvApi.get<string>(`/api/v2/dashboards/modules/kpiData/${moduleKey}/export?format=${format}&forGauge=true`, moduleRenderUrl);
    }
}
